import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const LouisVilleBatsLink = () => (
  <Link
    target="_blank"
    href="https://mlb.tickets.com/?agency=LOBM_MYTIXX&orgid=57630&_gl=1*gtuc0b*_gcl_au*MTYxNTIwODA1OC4xNzMxMTc1NjE0*_ga*NDg3OTU2MDUzLjE3MzExNzU2MTA.*_ga_F214WEVQWE*MTczMTk4ODczMS4xLjEuMTczMTk4ODc0OC4wLjAuMA..#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DLOBM_MYTIXX%26orgid%3D57630"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyTickets
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com.",
    description:
      "Click Continue and connect your Louisville Bats account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <LouisVilleBatsLink /> account within
        24 hours of purchase. Reach out to Live Fan Support or Louisville Bats
        at{" "}
        <Link
          href="tel:9017216000"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (901) 721-6000
        </Link>{" "}
        for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Louisville Bats Flex Plan work?",
    description:
      "The Louisville Bats Flex Plan allows fans to unlock the opportunity to purchase the Thunder at Louisville Slugger Field night on April 12, 2025. Simply log into your MLB.com and begin selecting your games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Louisville Bats{" "}
        <LouisVilleBatsLink /> Account.
      </>
    ),
  },
];
